import React from 'react'
import Loading from './Loading'
import ReCAPTCHA from 'react-google-recaptcha';
import image_contact from '../img/contact.png';
import mr_chat_icon from '../img/mr_chat_icon.png';
import x_chat_icon from '../img/x_chat_icon.png';
import './Contact.css';
import { useEffect, useState,useRef } from 'react';
import classNames from 'classnames';
import { motion } from "framer-motion";
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { ENDPOINTS, fetchWithLog } from '../config';

const Contact = ({ visibility, functions, pageList, data, resetDrag,serviceSelected,refreshPage }) => {
  const location = useLocation();
  const [paramValue, setParamValue] = useState(null);
  const [loadPage, setLoadPage] = useState(false);
  const buttonAnimationDuration = 5;
  const imageAnimationDuration = 2;
  const arrowAnimationDuration = 1;
  const textAnimationDuration = 2;
  const chatMessage = "Hi! Ready to make magic together? Share your details below. :)"
  const [selectedValue, setSelectedValue] = useState('value2'); // State for the selected value
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [subjectValue, setSubjectValue] = useState('');
  function openSendMessage(e) {
    //show message form using Router
    console.log("Clicked!")
  }

  if (refreshPage ){
    setLoadPage(false)
    console.log("Refresh!")
    functions.setRefreshPage(false)
  }
 // Add state to determine if it's a touch device
 const [isTouchDevice, setIsTouchDevice] = useState(false);
  // Detect if it's a touch device
  useEffect(() => {
    const onTouchStart = () => setIsTouchDevice(true);
    const onHoverStart = () => setIsTouchDevice(false);

    document.addEventListener('touchstart', onTouchStart);
    document.addEventListener('mouseenter', onHoverStart);

    return () => {
        document.removeEventListener('touchstart', onTouchStart);
        document.removeEventListener('mouseenter', onHoverStart);
    };
    }, []);
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission behavior
  
    //console.log(event)
    // Fetch input values
    const formData = {
      name: event.target.name.value,
      email: event.target.email.value,
      subject: event.target.subject.value,
      message: event.target.message.value,
      // Add reCAPTCHA validation if needed
    };
    
    if (!recaptchaValue) {
      // Show an error message or handle the lack of reCAPTCHA validation
      alert('Captcha validation failed!');
      return;
    }
    // Validate form inputs (add your own validation logic here)
    var url = ENDPOINTS.contactSubmit+"?name="+encodeURIComponent(formData.name)+"&email="+encodeURIComponent(formData.email)+"&subject="+encodeURIComponent(formData.subject)+"&message="+encodeURIComponent(formData.message)
    // Submit form data to the server
    try {
      const response = await fetchWithLog(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
    
      if (response.ok) {
        // Handle successful form submission (e.g., show success message)
       
        // Assuming the server response is in JSON format
        const data = await response.text();
        if (data.includes("Message has been sent")){
          alert('Message successfully! We shall get back to you soon!');
          window.location = "/"
    
        }else{

          alert('Form submission failed.');
        }
        console.log(data);
      } else {
        // Handle form submission error
        const errorData = await response.text(); // or response.json() if the server sends JSON in case of errors
        console.log(errorData);
        alert('Form submission failed.');
      }
    } catch (error) {
      // Handle network errors or other issues
      console.error('Error submitting form:', error);
      alert('Error submitting form:', error);
    }
    
  };
  const contactSubject = ["AI System Development","Data Analytics","Mobile Application Development","Website Development","Desktop Application Development","API Development","Automation","Music","Collaboration","UI/UX Design","Employment Opportunites","Other"];
  var aServiceSelected = "";

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const value = queryParams.get("service");
    setParamValue(value);
  }, []);

  if (serviceSelected && serviceSelected[1] != null && serviceSelected[1] != undefined){
    console.log("Service clicked "+serviceSelected[0] + " - "+serviceSelected[1])
    switch (serviceSelected[1]){

      case "DATA AANALYTIS": aServiceSelected = "Data Analytics"; break;
      case "MOBILE APPLICATIONS": aServiceSelected = "Mobile Application Development"; break;
      case "WEBSITES": aServiceSelected = "Website Development"; break;
      case "DESKTOP APPLICATIONS": aServiceSelected = "Desktop Application Development"; break;
      case "API DEVELOPMENT": aServiceSelected = "API Development"; break;
      case "AUTOMATION": aServiceSelected = "Automation"; break;
    }
  } else if (paramValue){
     // URL param e.g. ?service=api
    const serviceCodeSelected = paramValue
    switch (serviceCodeSelected){
      case "analytics": aServiceSelected = "Data Analytics"; break;
      case "mobile": aServiceSelected = "Mobile Application Development"; break;
      case "desktop": aServiceSelected = "Desktop Application Development"; break;
      case "api": aServiceSelected = "API Development"; break;
      case "web": aServiceSelected = "Website Development"; break;
      case "automation": aServiceSelected = "Automation"; break;
    }
  }

  // Sync initial subject from URL or serviceSelected into state
  useEffect(() => {
    if (aServiceSelected && contactSubject.includes(aServiceSelected)) {
      setSubjectValue(aServiceSelected);
    } else if (!subjectValue && contactSubject.length) {
      setSubjectValue(contactSubject[0]);
    }
  }, [paramValue, serviceSelected]);

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setLoadPage(true);
    }, 1); //  10 seconds
    return () => {
      clearTimeout(loadPage);
    };
  }, []);
  
  var choices = contactSubject.map((element) => (
    <option value={element}>{element}</option>
  ));
  const showContactSection = true//visibility.showContact;
  const pageSubtitle = "I'D LIKE TO TALK ABOUT..."
  const formRef = useRef(null);

  const resetForm = () => {
    if (formRef.current) {
      formRef.current.reset();
    }
    setSubjectValue(contactSubject[0] || '');
  };
  return (
    <div id='contact' className='region region-contact'>
      <div id="content" style={{ display: showContactSection ? 'block' : 'none' }}>
      <div className="pageTitle" id="contactBoxTitle">
          <h1>LET'S TALK</h1>
          <h4>{pageSubtitle}</h4>
        </div>
        
        <div className="row">
          <div className="col-md-1">

          </div>
          <div className="col-md-5" style={{left: '10px'}}>
            <motion.div className="contactBox" style={{display: isTouchDevice? 'none' : 'block'}} 
            animate={{ y: loadPage ? 0 : -500, opacity: loadPage ? 1 : 0 }}
              transition={{ duration: imageAnimationDuration }} initial={{ y: -500, opacity: 0 }} >
              <div className='contactBoxInner'>
                  <motion.div className='contactBoxTitle' animate={{ y: loadPage ? 0 : -500, opacity: loadPage ? 1 : 0 }}
              transition={{ duration: textAnimationDuration }}
              initial={{ y: -500, opacity: 0 }}>
                  <h1  style={{fontSize: '90px'}}>LET'S</h1>
                  <h1 style={{fontSize: '90px',
                      color: 'transparent',
                      WebkitTextStroke: '5px white',
                      WebkitTextFillColor: 'transparent'}}>TALK</h1>
                      </motion.div>
                  <br></br><br></br><br></br><br></br>
                  <h2 style={{textAlign: 'left'}}>A</h2>
                  <h2 style={{textAlign: 'left',
                      color: 'transparent',
                      WebkitTextStroke: '3px white',
                      WebkitTextFillColor: 'transparent'}}>RE BUE</h2>
                  <h3 style={{textAlign: 'left'}}>PARLONS</h3>
                  <h5 style={{textAlign: 'left'}}>Kōrero tāua</h5>
                  <h5 style={{textAlign: 'left'}}>Tuzungumze</h5>
                </div>
            </motion.div>
          </div>
          <div className="col-md-6">
            <motion.div className="contactFormBox" animate={{ y: loadPage ? 0 : -500, opacity: loadPage ? 1 : 0 }}
              transition={{ duration: imageAnimationDuration }} initial={{ y: -500, opacity: 0 }} >
                <div className='contactFormTitle' style={{ display: isTouchDevice ? 'none' : 'block', color: '#6CFF6C', textAlign: 'left', marginLeft: '50px', marginBottom: '16px' }}>
                  {pageSubtitle}
                </div>
                <form id='contactForm' onSubmit={handleSubmit} ref={formRef}>
                  <div className="chat-container">
                    <div className="chat-header">
                      <span>Let's chat</span>
                    </div>
                    <div className="chat-messages">
                      {/* Incoming: greeting */}
                      <div className="chat-bubble-incoming">
                        <div className="chat-avatar">
                          <img src={mr_chat_icon} alt="" />
                        </div>
                        <div className="chat-content">
                          <div className="chat-bubble">{chatMessage}</div>
                        </div>
                      </div>
                      {/* User: name */}
                      <div className="chat-bubble-outgoing">
                        <div className="chat-bubble">
                          <input type="text" required name='name' className='contactFormName' placeholder='Your name?' />
                        </div>
                      </div>
                      {/* User: email */}
                      <div className="chat-bubble-outgoing">
                        <div className="chat-bubble">
                          <input type="email" className='contactFormEmail' required name='email' placeholder='what@your.email.com' />
                        </div>
                      </div>
                      {/* User: subject */}
                      <div className="chat-bubble-outgoing">
                        <div className="chat-bubble">
                          <select
                            name="subject"
                            value={subjectValue || (contactSubject.length ? contactSubject[0] : '')}
                            onChange={(e) => setSubjectValue(e.target.value)}
                            required
                          >
                            {choices}
                          </select>
                        </div>
                      </div>
                      {/* User: message */}
                      <div className="chat-bubble-outgoing">
                        <div className="chat-bubble">
                          <textarea className='contactFormMessage' required name='message'
                            placeholder={(serviceSelected && contactSubject[serviceSelected[0]])
                              ? "Something like, Hi! I'd like to enquire about your " + contactSubject[serviceSelected[0]] + " services. What is your end goal?"
                              : "How can you help me? I'm looking for... (website, developer, collaboration, etc.)"}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="chat-actions" id='submitButton'>
                      <div className="recaptcha-wrapper">
                        <ReCAPTCHA sitekey="6LeDgMwlAAAAAMwrc-J5UWZPa0toYyPmtBo2uOeX" onChange={handleRecaptchaChange} />
                      </div>
                      <div className="button-group">
                        <motion.button type="submit" className='contactFormSubmit' whileHover={{ scale: 1.05, opacity: 0.9 }} whileTap={{ scale: 0.98 }}>
                          <i className="material-icons" style={{ fontSize: '18px' }}>&#xe163;</i> Send
                        </motion.button>
                        <motion.button type='reset' className='contactFormSubmit' onClick={resetForm} whileHover={{ scale: 1.05, opacity: 0.9 }} whileTap={{ scale: 0.98 }}>
                          <i className="material-icons" style={{ fontSize: '18px' }}>&#xf053;</i> Reset
                        </motion.button>
                      </div>
                    </div>
                  </div>
                </form>
              </motion.div>
          </div>
        </div>
      </div>
    </div>
  )

}

export default Contact